/* global axios */
// Contador de nao-lidas do Chat Interno para o badge do menu principal (bolinha
// numerica igual a dos tickets/canais). O item do menu e um SidebarGroupHeader,
// que so mostra o balao via `getterKeys.count` -> um GETTER do Vuex (um ref de
// composable nao encaixa nesse ponto). Fonte da verdade e o backend
// (GET .../kanban/internal_chats/unread_count); o websocket (App.vue) e a leitura
// de um chat (KanbanChats.vue) so disparam um fetch, sem bookkeeping +1/-1.
const state = {
  unreadCount: 0,
};

export const getters = {
  getUnreadCount: $state => $state.unreadCount,
};

export const mutations = {
  SET_UNREAD_COUNT($state, count) {
    $state.unreadCount = Number(count) || 0;
  },
};

export const actions = {
  async fetchUnread({ commit }, accountId) {
    if (!accountId) return;
    try {
      const { data } = await axios.get(
        `/api/v1/accounts/${accountId}/kanban/internal_chats/unread_count`
      );
      commit('SET_UNREAD_COUNT', data?.unread_messages || 0);
    } catch {
      // badge e acessorio: nunca pode quebrar a tela
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
